import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "../../jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { captureError } from "../../ErrorHandlers"
import { Activity } from "../../reducers/activitySlice"
import ActivityParser from "../../lib/activityParser"

const NODE = "http://jabber.org/protocol/activity"

export const retrieveAll = async (xmpp: Client): Promise<Activity[]> => {
  const items = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 4000,
  })

  const elements = items
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  return elements.map((element) => {
    return ActivityParser.parseItem(element)
  })
}

export const subscribeToUserActivities = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(client, wizardJid(client.jid!), NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      captureError(error, {
        origin: "XMPPOnOnline",
        extra: { message: "subscribeToUserActivities" },
      })
    }
  }
}
